import RentalDetailsR from './rentalDetail';

function IndexRentalDetails() {
  return <RentalDetailsR />;
}

export default IndexRentalDetails;
